/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router";
import Paper from "@mui/material/Paper";
import TextContainer from "../../Container/TextContainer";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import TextField from "@mui/material/TextField";
import Termination from "./Summary/Termination";
import PersonalData from "./Summary/PersonalData";
import { getCaseLink } from "../../../services/productService";
import { useForm } from "../../../provider/Form/FormProvider";
import { formValue } from "../../../services/formServiceFunctions";
import Contract from "./Summary/Contract";
import InsuranceData from "./Summary/InsuranceData";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

type SummaryProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

export default function Summary({ product, submitProps }: SummaryProps) {
  const location = useLocation();
  const stateField = location.state?.field;
  const { values, handleChange, handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <>
      <Paper elevation={4}>
        <TextContainer>
          <Typography variant={"h4"} sx={summaryStyle.headline}>
            Ihre Angaben
          </Typography>
          <Grid container>
            <Box id={"termination"} sx={summaryStyle.scrollToAnchor} />
            <Termination product={product} />

            <Box id={"contract"} sx={summaryStyle.scrollToAnchor} />
            <Contract product={product} />

            <Box id={"insuranceData"} sx={summaryStyle.scrollToAnchor} />
            <InsuranceData title={"Versicherung"} product={product} />

            <Box id={"personalData"} sx={summaryStyle.scrollToAnchor} />
            <PersonalData product={product} />
          </Grid>

          <form onSubmit={handleSubmit}>
            <TextField
              sx={summaryStyle.questionsTextArea}
              label={"Haben Sie offene Fragen?"}
              placeholder="Sie können uns gerne hier bereits Fragen oder Themen mitteilen, über die Sie sprechen möchten. Alle Antworten erhalten Sie dann direkt im persönlichen Telefonat."
              name={"personalTextMessage"}
              value={formValue(values, "personalTextMessage")}
              onChange={handleChange}
              multiline
              rows={"12"}
              maxRows={"12"}
              margin={"normal"}
              fullWidth
              slotProps={{
                inputLabel: {
                  shrink: true,
                }
              }}
            />
            <FormSubmit
              {...submitProps}
              hideBackButton={false}
              backLink={getCaseLink(product) + "/antrag/kuendigung"}
              backText={"Alles bearbeiten"}
              nextText={"Angaben speichern"}
              nextButtonSubtext={
                <small>
                  <LockIcon sx={{ height: "12px", width: "12px", paddingTop: "2px" }} /> SSL-zertifiziert - Wir schützen Ihre Daten!
                </small>
              }
            />
          </form>
        </TextContainer>
      </Paper>
    </>
  );
}
